module KendoWidgets
{
	export class LabelClickEvent
	{
		sender: KendoWidgets.Label;
		checked: boolean;
	}

	export class LabelOptions
	{
		text?: string | number;
		width?: string | number;
		height?: string | number;
		fontSize?: number;
		color?: ColorEnum | string;
		backgroundColor?: ColorEnum | string;
		display?: string;
		class?: string;
		fontWeight?: string | number;
		bold?: boolean;
		noBr?: boolean | NoBrSettings;
		css?: string;
		tel?: string;
		mail?: string;
		isPrimaryLabel?: boolean;
		tooltip?: string | boolean;
		type?: LabelTypeEnum;

		labelOutside?: string;
		labelOutsidePosition?: LabelPositionEnum;
		labelOutsideBold?: boolean;
		labelOutsidePrimary?: boolean;
		labelOutsideClass?: string;

		click?(e: KendoWidgets.LabelClickEvent): void;
	}

	export class Label extends kendo.ui.Widget implements KendoWidget
	{
		private _firstLoad: boolean;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.Label; }

		constructor(element: Element, options?: KendoWidgets.LabelOptions)
		{
			if (options == null)
				options = new KendoWidgets.LabelOptions();

			if (options.width == null) options.width = "auto";
			if (options.text == null) options.text = "";
			if (options.tooltip == null) options.tooltip = false;
			if (options.type == null) options.type = LabelTypeEnum.Normal;
			if (options.labelOutsidePrimary == null) options.labelOutsidePrimary = true;
			if (options.labelOutsideBold == null) options.labelOutsideBold = options.bold;

			super(element, options);

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			else if (options.width == "100%")
				(element as HTMLElement).style.cssText += "display: inline-block";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			let display = "display: inline-block;";
			//#region noBr
			if (options.noBr != null && options.noBr !== false)
			{
				if (options.noBr === true)
				{
					(element as HTMLElement).style.cssText += "white-space: nowrap; overflow:hidden; margin-bottom: -6px; text-overflow: ellipsis; display: inline-block;";
					if (options.width == "auto")
						(element as HTMLElement).style.cssText += "width: 100%";
				}
				else
				{
					display = "";
					(element as HTMLElement).style.cssText += "overflow: hidden; display: -webkit-box; -webkit-line-clamp: " + options.noBr.rowNumber + "; -webkit-box-orient: vertical;";
				}
			}
			//#endregion

			//#region Height
			if (typeof (options.height) == "number")
				options.height = options.height + "px";

			(element as HTMLElement).style.cssText += "height: " + options.height + ";" + display;
			//#endregion

			//#region Text
			this.text(options.text);

			if (options.tel != null)
				this.toTel(options.tel);
			else if (options.mail != null)
				this.toMail(options.mail);
			//#endregion

			//#region Font size
			if (options.fontSize != null)
				(element as HTMLLabelElement).style.cssText += "font-size: " + options.fontSize + "px";
			//#endregion

			//#region Color
			if (options.color != null)
			{
				let color = this.getColorByEnumOrString(options.color);
				(element as HTMLLabelElement).style.cssText += "color: " + color;
			}
			//#endregion

			//#region Background color
			if (options.backgroundColor != null)
			{
				let backgroundColor = this.getColorByEnumOrString(options.backgroundColor);
				(element as HTMLLabelElement).style.cssText += "background-color: " + backgroundColor;
			}
			//#endregion

			//#region Display
			if (options.display != null)
				(element as HTMLLabelElement).style.cssText += "display: " + options.display;
			//#endregion

			//#region Class
			$(element).addClass("k-label");
			if (options.class != null)
				$(element).addClass(options.class);
			//#endregion

			//#region Font weight
			if (options.fontWeight != null)
				(element as HTMLLabelElement).style.cssText += "font-weight: " + options.fontWeight;
			//#endregion

			//#region Bold
			if (options.bold === true)
				(element as HTMLLabelElement).style.cssText += "font-weight: 500";
			//#endregion

			//#region Is primary label
			if (options.isPrimaryLabel)
				(element as HTMLLabelElement).style.cssText += "color: #51B3E1;";
			//#endregion

			//#region Tooltip
			if (typeof (options.tooltip) == "string")
				(element as HTMLLabelElement).title = options.tooltip;
			//#endregion

			//#region Click
			let clickUserOverride = options.click;
			$(element).click((e: KendoWidgets.LabelClickEvent) =>
			{
				if (clickUserOverride != null)
					clickUserOverride(e);
			});

			if (options.click != null)
				(element as HTMLElement).style.cssText += "cursor: pointer;";
			//#endregion

			//#region Label outside
			if (options.labelOutside != null && !this._firstLoad)
			{
				$(element).wrap("<span></span>");
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				label.innerHTML = DOMPurify.sanitize(options.labelOutside);

				let color = (options.labelOutsidePrimary == true) ? KendoWidgets.ColorEnum.BlueVettore : "#000";
				label.style.cssText += "color: " + color + "; height: 20px;";

				if (options.fontSize != null)
					label.style.cssText += "font-size: " + options.fontSize + "px";
				else
					label.style.cssText += "font-size: 14px";

				//#region Label position
				if (options.labelOutsidePosition == null) options.labelOutsidePosition = LabelPositionEnum.Top;
				switch (options.labelOutsidePosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.style.cssText += "display: inline-block;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: auto";
							//else
							//	(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							element.parentElement!.style.cssText += "display: inline-block;";
							label.style.cssText += "margin-left: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: auto";
							//else
							//	(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				//#region LabelOutsideClass
				if (options.labelOutsideClass != null)
					$(label).addClass(options.labelOutsideClass);
				//#endregion

				(element.parentElement! as HTMLElement).style.cssText += "width: " + options.width;
				$(element).parent().attr("id", element.id + "Parent");

				if (options.labelOutsideBold === true)
					(label as HTMLLabelElement).style.cssText += "font-weight: 500";
			}
			//#endregion

			//#region CSS
			if (options.css != null)
			{
				if (options.labelOutside == null)
					(element as HTMLElement).style.cssText += options.css;
				else
					(element as HTMLElement).parentElement!.style.cssText += options.css;
			}
			//#endregion
		}

		// Renders sanitized HTML: several call sites intentionally pass markup
		// (lists, <b>/<br> formatting), so this is a genuine HTML sink, not a
		// plain-text one — DOMPurify.sanitize neutralizes the XSS risk without
		// breaking that contract.
		text(text?: string | number | Date)
		{
			if (text != null)
			{
				let options = (this.options as KendoWidgets.LabelOptions);

				//#region Type
				if (typeof (text) === "string")
					text = text;
				else if (Date.isValidDate(text))
					text = (text as Date).toItalyShortString();
				else if (typeof (text) === "number")
				{
					if (options.type == LabelTypeEnum.Currency)
						text = kendo.toString(text, "c2");
					else
						text = String(text);
				}
				//#endregion

				this.element[0].innerHTML = DOMPurify.sanitize(String(text));

				if ((this.options as KendoWidgets.LabelOptions).tooltip === true)
					(this.element[0] as HTMLLabelElement).title = String(text);
			}
			return this.element[0].innerHTML;
		}

		label(label?: string)
		{
			if (label != null)
				$("#" + this.element.attr("id") + "Label").html(DOMPurify.sanitize(label));

			return $("#" + this.element.attr("id") + "Label").html();
		}

		visible(visibleStatus?: boolean)
		{
			let options = this.getOptions();
			let element = (options.labelOutside != null) ? this.element.parent() : this.element;

			if (visibleStatus != null)
			{
				if (visibleStatus)
					element.show();
				else
					element.hide();
			}
			return element.is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}

		clear(defaultValue?: string | number | Date)
		{
			let options = (this.options as KendoWidgets.LabelOptions);
			if (defaultValue != null)
			{
				//#region Type
				if (typeof (defaultValue) === "string")
					defaultValue = defaultValue;
				else if (Date.isValidDate(defaultValue))
					defaultValue = (defaultValue as Date).toItalyShortString();
				else if (typeof (defaultValue) === "number")
				{
					if (options.type == LabelTypeEnum.Currency)
						defaultValue = kendo.toString(defaultValue, "c2");
					else
						defaultValue = String(defaultValue);
				}
				//#endregion
			}
			else
				defaultValue = "";

			this.element[0].innerHTML = DOMPurify.sanitize(String(defaultValue));
		}

		css(css: string)
		{
			this.element[0].style.cssText += css;
		}

		toTel(phoneNumber: string, styleAsLink?: boolean)
		{
			this.element[0].innerHTML = DOMPurify.sanitize("<a href='tel:" + phoneNumber + "'>" + this.text() + "</a>");
			if (styleAsLink == false)
			{
				let color = (this.options as KendoWidgets.LabelOptions).color;
				this.element.find("a")[0].style.cssText = "text-decoration: none; color: " + ((color != null) ? color : "#000000");
			}
		}

		toMail(mail: string, styleAsLink?: boolean)
		{
			this.element[0].innerHTML = DOMPurify.sanitize("<a href='mailto:" + mail + "'>" + this.text() + "</a>");
			if (styleAsLink == false)
			{
				let color = (this.options as KendoWidgets.LabelOptions).color;
				this.element.find("a")[0].style.cssText = "text-decoration: none; color: " + ((color != null) ? color : "#000000");
			}
		}

		private getColorByEnumOrString(color: ColorEnum | string): string
		{
			switch (color)
			{
				case KendoWidgets.ColorEnum.Default: return "#000000";
				case KendoWidgets.ColorEnum.Black: return "#000000";
				case KendoWidgets.ColorEnum.Red: return "#FF0000";
				case KendoWidgets.ColorEnum.Green: return "#46C646";
				case KendoWidgets.ColorEnum.BlueVettore: return "#51B3E1";
				case KendoWidgets.ColorEnum.BlueVettoreLight: return "#E3F1FA";
				default: return color;
			}
		}

		getOptions()
		{
			return (this.options as LabelOptions);
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			let options = this.getOptions();
			if (options.labelOutside != null)
				this.element.parent().appendTo(element);
			else
				this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			let options = this.getOptions();
			if (options.labelOutside != null)
				this.element.parent().prependTo(element);
			else
				this.element.prependTo(element);
		}
	}

	export enum ColorEnum
	{
		Default = "#000000",
		Black = "#000000",
		Red = "#FF0000",
		LightRed = "#ffb3b3",
		Green = "#46C646",
		LightGreen = "#9ae29a",
		BlueVettore = "#51B3E1",
		BlueVettoreLight = "#E3F1FA"
	}

	export enum LabelTypeEnum
	{
		Normal,
		Currency
	}

	export enum LabelPositionEnum
	{
		Top,
		Left,
		Right,
		Bottom
	}

	class NoBrSettings
	{
		rowNumber?: number;
	}

	Label.fn = Label.prototype;
	Label.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	Label.fn.options.name = "Label";
	kendo.ui.plugin(Label);
}

interface JQuery
{
	kendoLabel(options?: KendoWidgets.LabelOptions): JQuery;
	data(key: "kendoLabel"): KendoWidgets.Label;
}